import React, { Component } from 'react';
import { Tabs, Button, message, Select, Tooltip, Icon, Modal, Checkbox } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
//import SearchRetrieve from '../../common/SearchRetrieve.new.js';
const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class Filter extends Component {
    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

class QueryRegion extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const params = this.props.splitParams(searchParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryRandomVisitCompare,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                type: 'SITE',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                datas.forEach(el => {
                    el.date = searchParams.date
                });
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'date',
            key: 'date',
            fixed: 'left',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 80,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
            render: (text, row) => {
                const { colorRed } = row;
                return ( <span style={{color:colorRed?'red':'rgba(0,0,0,.65)'}}>{text}</span> )
            }
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 80,
        },{
            title: '项目PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 80,
        }, {
            title: '项目PM姓名',
            dataIndex: 'pmUser',
            key: 'pmUser',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 120,
        },{
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
        }, {
            title: '中心科室名称',
            dataIndex: 'siteDepartmentName',
            key: 'siteDepartmentName',
            width: 130,
        }, {
            title: '截止当月中心累计已入组数量',
            dataIndex: 'accumulativeRandomAmount',
            key: 'accumulativeRandomAmount',
            width: 120,
        }, {
            title: '截止当月累计完成访视数量',
            dataIndex: 'accumulativeVisitAmount',
            key: 'accumulativeVisitAmount',
            width: 120,
        }, {
            title: '截止当月中心累计已确认标准访视数量',
            dataIndex: 'accumulativeStandardVisitAmount',
            key: 'accumulativeStandardVisitAmount',
            width: 120,
        }, {
            title: '截止当月中心累计已消耗FTE',
            dataIndex: 'accumulativeFte',
            key: 'accumulativeFte',
            width: 120,
        }, {
            title: '当月中心计划入组数量',
            dataIndex: 'planRandomAmountShow',
            key: 'planRandomAmountShow',
            width: 120,
        }, {
            title: '当月中心计划访视数量',
            dataIndex: 'planVisitAmount',
            key: 'planVisitAmount',
            width: 120,
        }, {
            title: '当月中心计划标准访视数量',
            dataIndex: 'planStandardVisitAmount',
            key: 'planStandardVisitAmount',
            width: 120,
        }, {
            title: '当月中心计划FTE',
            dataIndex: 'planFte',
            key: 'planFte',
            width: 120,
        }, {
            title: '当月中心实际入组数量',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 120,
        }, {
            title: '当月中心实际访视数量',
            dataIndex: 'visitAmount',
            key: 'visitAmount',
            width: 120,
        }, {
            title: '当月中心已确认标准访视数量',
            dataIndex: 'standardVisitAmount',
            key: 'standardVisitAmount',
            width: 120,
        }, {
            title: '当月中心确认FTE',
            dataIndex: 'comfirmFte',
            key: 'comfirmFte',
            width: 120,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byCrc"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class QueryInvArea extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const params = this.props.splitParams(searchParams);
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryRandomVisitCompare,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                type: 'INV',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                datas.forEach(el => {
                    el.date = searchParams.date
                });
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const columns = [{
            title: '统计月份',
            dataIndex: 'date',
            key: 'date',
            fixed: 'left',
            width: 80,
        },{
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            fixed: 'left',
            width: 120,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
            render: (text, row) => {
                const { colorRed } = row;
                return ( <span style={{color:colorRed?'red':'rgba(0,0,0,.65)'}}>{text}</span> )
            }
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 120,
        },{
            title: '项目PM工号',
            dataIndex: 'pmCode',
            key: 'pmCode',
            width: 100,
        }, {
            title: '项目PM姓名',
            dataIndex: 'pmUser',
            key: 'pmUser',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 120,
        }, {
            title: '合同计划随机(入组)数量',
            dataIndex: 'contractPlanRandomAmount',
            key: 'contractPlanRandomAmount',
            width: 120,
        }, {
            title: '津石随机（入组）计划数',
            dataIndex: 'jinshiPlanRandomAmount',
            key: 'jinshiPlanRandomAmount',
            width: 120,
        }, {
            title: '偏差',
            dataIndex: 'deviation',
            key: 'deviation',
            width: 80,
        }, {
            title: '津石计划访视数量',
            dataIndex: 'jinshiPlanVisitAmount',
            key: 'jinshiPlanVisitAmount',
            width: 100,
        }, {
            title: '津石计划标准访视数量',
            dataIndex: 'jinshiPlanStandardVisitAmount',
            key: 'jinshiPlanStandardVisitAmount',
            width: 100,
        }, {
            title: '截止当月累计完成随机（入组）数量',
            dataIndex: 'accumulativeRandomAmount',
            key: 'accumulativeRandomAmount',
            width: 120,
        }, {
            title: '截止当月累计完成访视数量',
            dataIndex: 'accumulativeVisitAmount',
            key: 'accumulativeVisitAmount',
            width: 120,
        }, {
            title: '截止当月累计已确认标准访视数量',
            dataIndex: 'accumulativeStandardVisitAmount',
            key: 'accumulativeStandardVisitAmount',
            width: 120,
        }, {
            title: '随机（入组）完成率',
            dataIndex: 'randomCompleteRate',
            key: 'randomCompleteRate',
            width: 100,
            render: text => text+'%'
        }, {
            title: '访视数量完成率',
            dataIndex: 'visitCompleteRate',
            key: 'visitCompleteRate',
            width: 120,
            render: text => text+'%'
        }, {
            title: '标准访视完成率',
            dataIndex: 'standardVisitCompleteRate',
            key: 'standardVisitCompleteRate',
            width: 120,
            render: text => text+'%'
        }, {
            title: 'Q1计划入组数',
            dataIndex: 'q1PlanRandom',
            key: 'q1PlanRandom',
            width: 100,
        }, {
            title: 'Q2计划入组数',
            dataIndex: 'q2PlanRandom',
            key: 'q2PlanRandom',
            width: 100,
        }, {
            title: 'Q3计划入组数',
            dataIndex: 'q3PlanRandom',
            key: 'q3PlanRandom',
            width: 100,
        }, {
            title: 'Q4计划入组数',
            dataIndex: 'q4PlanRandom',
            key: 'q4PlanRandom',
            width: 100,
        }, {
            title: 'Q1累计入组数',
            dataIndex: 'q1AccumulativeRandom',
            key: 'q1AccumulativeRandom',
            width: 100,
        }, {
            title: 'Q2累计入组数',
            dataIndex: 'q2AccumulativeRandom',
            key: 'q2AccumulativeRandom',
            width: 100,
        }, {
            title: 'Q3累计入组数',
            dataIndex: 'q3AccumulativeRandom',
            key: 'q3AccumulativeRandom',
            width: 100,
        }, {
            title: 'Q4累计入组数',
            dataIndex: 'q4AccumulativeRandom',
            key: 'q4AccumulativeRandom',
            width: 100,
        },{
            title: (
                <span>
                    Q1季度差值
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'Q1累计入组数-Q1计划入组数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'q1Deviation',
            key: 'q1Deviation',
            width: 120,
        }, {
            title: (
                <span>
                    Q2季度差值
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'Q2累计入组数-Q2计划入组数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'q2Deviation',
            key: 'q2Deviation',
            width: 120,
        }, {
            title: (
                <span>
                    Q3季度差值
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'Q3累计入组数-Q3计划入组数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'q3Deviation',
            key: 'q3Deviation',
            width: 120,
        }, {
            title: (
                <span>
                    Q4季度差值
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'Q4累计入组数-4计划入组数'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'q4Deviation',
            key: 'q4Deviation',
            width: 120,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class VisitNumComparison extends Component {
    state = {
        panes: [{
            title: '中心计划入组数&访视数和实际对比',
            key: 'queryRegion',
            content: null,
        }, {
            title: '项目计划入组数&访视数和实际对比',
            key: 'queryInvArea',
            content: null,
        }],
        activeKey: 'queryRegion',
        businessList: [],
        searchParams: {},
        visible:false,
        exportTypeSite:false,
        exportTypeInv:false,

    }

    componentDidMount() {
        this.queryWithLevelByParams();
        this.updatePanes();
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { trueMonth, trueYear } = res;
            const { searchParams } = this.state;
            const date = `${trueYear}-${trueMonth < 10 ? `0${trueMonth}` : trueMonth}`;
            searchParams.date = date;
            this.setState({
                searchParams,
                curParams: {...searchParams},
            }, () => {
                this.search();
            });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    search = () => {
        const { searchParams } = this.state;
        searchParams.date &&
        this.setState({
            searchParams: {...searchParams}
        }, () => {
            const { searchParams } = this.state;
            this.childRef.search(searchParams);
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    export = (type) => {
        const { activeKey, sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportRandomVisitCompare,
            data: {
                ...sortParams,
                ...params,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    updatePanes = () => {
        const { panes, activeKey, searchParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'queryRegion') {
            RenderContent = QueryRegion;
        } else if (activeKey == 'queryInvArea') {
            RenderContent = QueryInvArea;
        } 
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} searchParams={searchParams} splitParams={this.splitParams}/>;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes },() => this.search());
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    onOk = () =>{
        const {exportTypeSite, exportTypeInv} = this.state;
        if(exportTypeSite || exportTypeInv){
            exportTypeSite &&this.export('SITE');
            exportTypeInv && this.export('INV');
            this.onCancel();
        }else{
            message.error('请选择导出内容')
        }
        
    }

    onCancel = () =>{
        this.setState({
            visible:false,
            exportTypeSite:false,
            exportTypeInv:false,
        })
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, businessList, searchParams, visible, exportTypeSite,exportTypeInv } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <div style={{marginTop: 20, marginBottom: 4, float:'fixed'}}>
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    businessList={businessList}
                    buttons={[
                        <Button key="export" type="primary" onClick={()=>{this.setState({visible:true})}} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                </div>
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} >{pane.content}</TabPane>)}
                </Tabs>
                <Modal
                    title='导出'
                    visible={visible}
                    className="creat-modal EditPersonModal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="350px"
                    onOk={this.onOk}
                    onCancel={this.onCancel}
                >
                    <div style={{padding:'0 20px'}}>
                        <div style={{marginBottom:'10px'}}>请选择导出内容:</div>
                        <Checkbox checked={exportTypeSite} onChange={(e) => {this.setState({exportTypeSite:!exportTypeSite})}} style={{marginBottom:'10px'}}>中心计划入组数&访视数和实际对比</Checkbox>
                        <br />
                        <Checkbox checked={exportTypeInv} onChange={(e) => {this.setState({exportTypeInv:!exportTypeInv})}}>项目计划入组数&访视数和实际对比</Checkbox>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default VisitNumComparison;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/visitNumComparison.js